import { InboxOutlined, UploadOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import Upload, { UploadChangeParam } from 'antd/lib/upload';
import Dragger from 'antd/lib/upload/Dragger';
import React from 'react';
import styled from 'styled-components';
import { getEncryptedFilesLinks } from 'utils';

import { ICommonInputProps } from './types';

const DraggerStyled = styled(Dragger)`
  height: auto !important;
  & .ant-upload-list-item-card-actions-btn {
    margin: 0 !important;
  }
`;

const FileInput: React.FC<ICommonInputProps> = ({
  name,
  inputClassName,
  onChange,
  value,
  defaultValue,
  inputSettings,
  onBlur,
}) => {
  const props = {
    name,
    headers: {
      authorization: 'authorization-text',
    },
    onChange(info: UploadChangeParam) {
      if (inputSettings?.singleFileOnly) {
        const fileListTemp = info.fileList.length ? [info.fileList[info.fileList.length - 1]] : [];
        onChange?.(fileListTemp);
      } else {
        onChange?.(info.fileList);
      }
      // if (info.file.status !== 'uploading') {
      //   console.log(info.file, info.fileList);
      // }
      // if (info.file.status === 'done') {
      //   message.success(`${info.file.name} file uploaded successfully`);
      //   helpers.setValue(info);
      // } else if (info.file.status === 'error') {
      //   helpers.setError(`${info.file.name} file upload failed.`);
      //   message.error(`${info.file.name} file upload failed.`);
      // }
    },
    fileList: value,
    onBlur,
  };
  const FileInputContainer = inputSettings?.uploadStyle === 'small' ? Upload : DraggerStyled;

  return (
    <FileInputContainer
      className={`file-input ${inputClassName}`}
      accept={inputSettings?.accept}
      defaultFileList={defaultValue}
      multiple={!inputSettings?.singleFileOnly}
      beforeUpload={() => false}
      onPreview={async (f) => {
        let { url } = f;
        if (f.url?.includes('token=')) {
          const { viewUrl } = await getEncryptedFilesLinks(f.uid, f.name);
          url = viewUrl;
        }
        if (url) window.open(url);
      }}
      {...inputSettings}
      {...props}>
      {inputSettings?.uploadStyle !== 'small' && (
        <div>
          <p className='ant-upload-drag-icon'>
            <InboxOutlined />
          </p>
          <p className='ant-upload-text'>Click or drag file to this area to upload</p>
          <p className='ant-upload-hint'>
            Support for a single{inputSettings?.multiple === false ? '' : ' or bulk'} upload
          </p>
        </div>
      )}
      {inputSettings?.uploadStyle === 'small' && (
        <Button className='!mb-0' icon={<UploadOutlined />}>
          Upload
        </Button>
      )}
    </FileInputContainer>
    // <Upload className={className} {...props}>
    //   <Button style={{ marginBottom: 0 }} icon={<UploadOutlined />}>
    //     Click to Upload
    //   </Button>
    // </Upload>
  );
};

export default React.memo(FileInput);
